import React from 'react';
import { MoonIcon, BrainIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="py-12 md:py-20" data-id="element-461">
      <div className="flex items-center justify-center mb-8" data-id="element-462">
        <MoonIcon className="h-8 w-8 text-indigo-600 mr-2" data-id="element-463" />
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-indigo-900" data-id="element-464">
          NightPhase
        </h1>
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-800 mb-8 px-4" data-id="element-465">
        The Executive's Secret to Peak Performance Through Optimal Sleep
      </h2>
      <div className="flex flex-col md:flex-row gap-6 md:gap-8 mb-16" data-id="element-466">
        <div className="md:w-1/2" data-id="element-467">
          <img src="https://images.pexels.com/photos/7845147/pexels-photo-7845147.jpeg" alt="middle-aged businessman working at his desk" className="rounded-xl shadow-md w-full h-64 md:h-80 object-cover" data-id="element-468" />
        </div>
        <div className="md:w-1/2 bg-white rounded-xl shadow-md p-6 md:p-8" data-id="element-469">
          <h3 className="text-xl font-semibold mb-4 text-indigo-800" data-id="element-470">
            Marcus's Story: From Burnout to Breakthrough
          </h3>
          <div className="prose max-w-none text-slate-700" data-id="element-471">
            <p className="mb-4" data-id="element-472">
              As CFO of a rapidly growing tech company, Marcus was experiencing
              chronic insomnia that left him relying on six cups of coffee daily
              just to function, with his decision-making and leadership visibly
              suffering. After trying numerous solutions with little success, a
              fellow executive introduced him to NightPhase transdermal sleep
              patches, which transformed his sleep quality and restored his
              mental clarity, decision-making speed, and leadership confidence
              within weeks.
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center space-x-2 mb-8" data-id="element-473">
        <BrainIcon className="h-6 w-6 text-indigo-600" data-id="element-474" />
        <h2 className="text-2xl font-bold text-slate-800" data-id="element-475">
          9 Performance Benefits of Optimal Sleep
        </h2>
      </div>
      <p className="text-center text-slate-600 mb-12 px-4" data-id="element-476">
        Discover how NightPhase's revolutionary transdermal sleep technology
        delivers measurable performance advantages for today's high-achieving
        professionals.
      </p>
    </section>;
};